<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <div class="container-fluid">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="dialogRef.close()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Ruta del servicio
        </h4>
        <div class="row" *ngIf="cargo && showMap">
            <p class="col-12 my-3 text-bold">
                A continuación se muestra la ruta del servicio. {{type === 'confirm' ? 'Por favor confirme que las
                direcciones son correctas.' : ''}}
            </p>
            <app-standard-map [options]="mapOptions" class="route-visualization-map"
                (mapReady)="setMapOptions()"></app-standard-map>
        </div>
        <div *ngIf="!showMap || !cargo" class="alert alert-danger text-center">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <span class="text-bold">No se pudo cargar la ruta del servicio. Verifique que todas sus direcciones tengan
                coordenadas válidas.</span>
        </div>
        <div class="button-container mt-4">
            <button mat-raised-button color="primary" type="submit" class="bg-color-primary">
                {{type === 'confirm' ? 'Confirmar' : 'Cerrar'}}
            </button>
        </div>
    </div>
</form>